import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../../../api/services/project.services';
import { BomLine } from '../../../api/models/bom-line';
import { BomTableService } from '../../bom-table/bom-table.service';
import { MarketService } from '../../../api/services/market.service';
import { Market } from '../../../api/models/market-model';
import { AnalyticsService } from '../../../api/services/analytics.service';

@Component({
  selector: 'app-boms',
  templateUrl: './boms.component.html',
  styleUrls: ['./boms.component.scss'],
  providers: [BomTableService]
})
export class BomsComponent implements OnInit {

  boms: {name: string, id: string}[] = [];

  masterBomData = new Subject<BomLine[]>();

  bomLines: BomLine[] = [];

  currentBomId: string;

  @Input() marketId: string;

  market: Market = new Market();

  @Output() selected: EventEmitter<any[]> = new EventEmitter<any[]>();

  itemSearchText: string;
  searchSubject: Subject<string> = new Subject<string>();
  warningMessages$: Subject<string[]> = new Subject();
  warningMessagesList: string[] = [];

  constructor(private projectService: ProjectService,
              private marketService: MarketService,
              private toastr: ToastrService,
              private analyticsService: AnalyticsService
  ) {
      this.searchSubject.asObservable().debounceTime(1000)
        .subscribe(itemSearchText => {
          this.itemSearchText = itemSearchText;
        });
    }

  onBomChange(bomId: string) {
    this.currentBomId = bomId;
    this.projectService.getBomLinesWithConsignment(bomId, this.market.accountNumber)
    .subscribe(data => {
      this.masterBomData.next(data);
      this.bomLines = [];
    });
  }

  onRowsChange(bomLines: BomLine[]) {
    this.bomLines = bomLines.filter(b => b.quantity > 0);
  }

  submitRows() {
    this.bomLines.forEach(bomLine => {
      const product = bomLine.details;
      if (product && bomLine.quantity < product.minimumQuantity) {
        bomLine.quantity = product.minimumQuantity;
        if (product.isCableItem) {
          bomLine.isCableSkuQtyAdjusted = true;
        } 
        let adjustedSkuWarningMsg: string = 'The quantity was adjusted to ' + product.minimumQuantity + ' to meet the minimum quantity' +
          ' required for SKU ' + bomLine.partNumber;
        this.pushWarningMessagesIntoArray(adjustedSkuWarningMsg);
        this.loadWarningMessages();
      }
      if (product && product.isConsignedItem && !bomLine.isConsignmentItem) {
        bomLine.isConsignmentItem = product.isConsignedItem;
      }
    });
    this.selected.emit(this.bomLines);
    this.projectService.addRowsToWorksheetClicked.next(true);
    this.onAddRowsSuccess();
    // We need to reset the quantities
    this.onBomChange(this.currentBomId);
  }

  private onAddRowsSuccess() {
    this.toastr.success('Rows added to worksheet!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  ngOnInit() {
    this.projectService.getAllMasterBomByMarket(this.marketId)
    .subscribe(boms => {
      this.boms = boms || [];
    });
    this.marketService.getMarket(this.marketId).subscribe(result => {
      this.market = result;
    }); 
  }

  searchItems(value) {
    this.searchSubject.next(value.trim());
    this.sendDataToAnalytics(value);
  }

  private sendDataToAnalytics(value: any) {
    this.analyticsService.trackProductSearchWorksheetBOM(value.trim());
  }

  clearSearch() {
    let value ="";
    this.searchSubject.next(value.trim());
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    this.searchItems(pastedText);
  }

  private pushWarningMessagesIntoArray(message: string): void {
    if (this.warningMessagesList.indexOf(message) == -1) {
      this.warningMessagesList.push(message);
    }
  }

  dismissWarningMessages(){
    this.warningMessagesList = [];
    this.warningMessages$.next(undefined);
  }

  private loadWarningMessages(): void {
    this.warningMessages$.next(undefined);
    this.warningMessages$.next(this.warningMessagesList);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/boms/boms.component.ts